<template>
  <div class="em-wrap">
    <modal name="email" class="em-modal" @before-close="onClose" :adaptive="true" height="auto" width="90%" :maxWidth="560">
      <div class="em-dialog">
        <div class="em-dialog-header">
          <div class="em-dialog-header-left">
            <span class="em-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16v16H4z"/>
                <path d="M22 6l-10 7L2 6"/>
              </svg>
            </span>
            <div>
              <h2 class="em-dialog-title">Edit Email</h2>
              <p class="em-dialog-sub">{{ runner.runner && runner.runner.user ? runner.runner.user.email : 'No email set' }}</p>
            </div>
          </div>
          <button class="em-close-btn" type="button" title="Close" @click="$modal.hide('email')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div class="em-dialog-body">
          <label class="em-field">
            <span class="em-label">Email address</span>
            <input type="text" v-model="newemail" maxlength="255" name="newemail" placeholder="runner@example.com" class="em-input">
          </label>
        </div>
        <div class="em-dialog-footer">
          <button class="em-cancel-btn" type="button" @click="$modal.hide('email')">Cancel</button>
          <button class="em-save-btn" type="button" v-on:click="Save(newemail)">Save</button>
        </div>
      </div>
    </modal>  
  </div>
  
</template>

<script>
  import RunnersByRaceService from '../../../services/runnersByRace'
  import { db } from '../../../firebase'

  export default {
    name: 'edit-email',
    data: () => ({
        newemail:'',
        finishDate: ''
    }),
    props:{
            runner: {
                type:Object
            },
            show:false,
        },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
        onClose() {
                this.$emit('closed', true)
        },
        openEditModal() {
          this.$modal.show('email')
        },
        Save (email) {
        let  that = this
          RunnersByRaceService.updateEmail(this.runner.runner.id, email).then((response) => {
            that.$emit('saved', response.data)
            that.$modal.hide('email')
            that.newemail = ''
          },
          (error) =>{
            console.log(error)
          })
        }
    },
    created() {
     this.$watch('show', function (val) {
      })
    },
    
    watch: {
        show(oldVal, newVal) {
            if(this.show){
             this.openEditModal()
            }
        }
    },
  }
</script>
<style scoped>
.em-dialog {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.em-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.75rem;
  border-bottom: 1px solid #f0f0f5;
}
.em-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.em-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
}
.em-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.em-dialog-sub {
  font-size: 12px;
  color: #8a8a9a;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}
.em-close-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #8a8a9a;
  cursor: pointer;
}
.em-close-btn:hover {
  color: #c0392b;
  border-color: #ffd6d6;
}
.em-dialog-body {
  padding: 1.5rem 1.75rem;
}
.em-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.em-label {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
}
.em-input {
  height: 40px;
  width: 100%;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  background: #fafafa;
  color: #1a1a2e;
  font-size: 14px;
  padding: 0 0.75rem;
}
.em-input:focus {
  outline: none;
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}
.em-dialog-footer {
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.em-cancel-btn,
.em-save-btn {
  height: 36px;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.em-cancel-btn {
  border: 1px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
}
.em-save-btn {
  border: none;
  background: #5b4fcf;
  color: #fff;
}
.em-save-btn:hover {
  background: #4338ca;
}
</style>



// WEBPACK FOOTER //
// EditEmail.vue?d3ad6bea